import styled from '@emotion/styled';
import { alpha, Button } from '@mui/material';
import { shouldForwardProps } from '../../../utils';

const BigSideNavItemButton = styled(Button, shouldForwardProps)<{ isSelected: boolean }>`
    display: flex;
    justify-content: start;
    align-items: center;
    flex-direction: row;
    height: 56px;
    width: 100%;
    color: ${({ theme, isSelected }) =>
        isSelected ? theme.colors.onPrimaryDark : theme.colors.surfaceVariant};
    background-color: ${({ isSelected, theme }) =>
        isSelected ? theme.colors.darkSurfaceTint : 'transparent'};
    border-radius: 100px;

    &:hover {
            background-color: ${({ theme, isSelected }) => isSelected ? theme.colors.primaryContainer : alpha(theme.colors.darkSurfaceTint, 0.08)};
        }
`;

export { BigSideNavItemButton };
